export default "__VITE_PUBLIC_ASSET__bfa6bcaa__"